module.exports = "https://cb-static.prod-my.games/promo/twitchregionselect/img/footer-logo-booming-games.93ed3cb4.svg";